import React from 'react';
import PropTypes from 'prop-types';
import { LuAlertTriangle, LuRefreshCw } from 'react-icons/lu';
import Button from 'components/common/Button';

// Shared error card — used by the app-wide error boundary (render crashes)
// and the global request-error overlay (timeouts / network drops).
const AppErrorFallback = ({ icon: Icon, title, message, onDismiss }) => (
  <div
    role="alertdialog"
    aria-labelledby="app-error-title"
    aria-describedby="app-error-message"
    className="tw-w-full tw-max-w-md tw-mx-4 tw-bg-white tw-border tw-border-solid tw-border-slate-200 tw-rounded-xl tw-shadow-lg tw-p-6 sm:tw-p-8 tw-text-center"
  >
    <div className="tw-mx-auto tw-mb-4 tw-flex tw-h-12 tw-w-12 tw-items-center tw-justify-center tw-rounded-xl tw-bg-red-50 tw-text-red-600 tw-ring-8 tw-ring-red-50/50">
      <Icon size={22} aria-hidden="true" />
    </div>

    <h2 id="app-error-title" className="tw-text-lg tw-font-semibold tw-text-slate-900 tw-mb-1.5">
      {title}
    </h2>
    <p id="app-error-message" className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-mb-6">
      {message}
    </p>

    <div className="tw-flex tw-flex-col-reverse sm:tw-flex-row tw-items-stretch sm:tw-items-center tw-justify-center tw-gap-2">
      {onDismiss && (
        <Button variant="secondary" onClick={onDismiss} className="sm:tw-min-w-[110px]">
          Dismiss
        </Button>
      )}
      <Button
        variant="primary"
        leftIcon={LuRefreshCw}
        onClick={() => window.location.reload()}
        className="sm:tw-min-w-[110px]"
      >
        Refresh page
      </Button>
    </div>

    <p className="tw-mt-5 tw-mb-0 tw-text-xs tw-text-slate-400">
      Still not working?{' '}
      <a href="mailto:portal@pebsteel.com.vn" className="tw-text-primary-600 hover:tw-text-primary-700 tw-font-medium">
        Contact IT Department
      </a>
    </p>
  </div>
);

AppErrorFallback.propTypes = {
  icon: PropTypes.elementType,
  title: PropTypes.string,
  message: PropTypes.string,
  onDismiss: PropTypes.func,
};
AppErrorFallback.defaultProps = {
  icon: LuAlertTriangle,
  title: 'Something went wrong',
  message: 'Try refreshing the page. If the issue persists, please contact the IT Department.',
  onDismiss: null,
};

export default AppErrorFallback;
